<template>
  <form-filtered-multiselect
    :value="storedServiceLevels"
    :options="serviceLevelOptions"
    :placeholder="placeholder"
    :limit-height="limitHeight"
    :hide-selected="hideSelected"
    :disabled="disabled"
    track-by="value"
    label="label"
    @input="onServiceLevelsSelected" />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    limitHeight: {
      type: Boolean,
      default: false
    },
    selectedKeys: {
      default: () => {
        return []
      }
    },
    placeholder: {
      default: 'Please select Service Levels'
    },
    hideSelected: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      options: [],
      storedServiceLevels: []
    }
  },
  computed: {
    ...mapGetters('serviceLevel', ['serviceLevelOptions'])
  },
  watch: {
    selectedKeys: function (newVal) {
      this.storedServiceLevels = newVal
    }
  },
  created () {
    this.storedServiceLevels = this.selectedKeys
  },
  methods: {
    onServiceLevelsSelected (serviceLevels) {
      this.$emit('valuesSelected', serviceLevels)
    }
  }
}
</script>

<style>

</style>
